export default "__VITE_ASSET__tSv$kArV__"